import types from './action-types';
import service from './service';

export const axesRangesChanged = (chartName, xMin, xMax, yMin, yMax) => {
    return (dispatch, getState) => {
        service.saveChartScaling(chartName, xMin, xMax, yMin, yMax);
    }
};

export const dataPreloaded = (charName, data) => {
    return dataLoaded(charName, data);
};

export const clearChart = chartName => {
    return {
        type: types.CLEAR_CHART_STATE,
        chartName
    };
};

const dataLoaded = (chartName, data) => {
    return {
        type: types.DATA_LOADED,
        chartName: chartName,
        chartData: data,
    };
};



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/actions.js